#
#    @author Jaromír Navara [BG] <web@bagricek.cz>
#    26.8.2016 4:14
#
# A class-based template for jQuery plugins in Coffeescript
#
#     $('.target').oblekani({ paramA: 'not-foo' });
#     $('.target').oblekani('myMethod', 'Hello, world');
#
# Check out Alan Hogan's original jQuery plugin template:
# https://github.com/alanhogan/Coffeescript-jQuery-Plugin-Template
#
# REQUIRED: jQuery, ionSound
#
(($, window) ->

  # Define the plugin class
  class Oblekani
    $svgWrapper: null
    $oblekaniImage: null
    $itemsWrapper: null
    victoryPage: false
    sliderActive: null

    defaults:
      done: "#oblekani_done"

    constructor: (el, options) ->
      @options = $.extend({}, @defaults, options)
      @$el = $(el)
      @$itemsWrapper = @$el.find "#items"
      @$oblekaniImageWrapper = @$el.find "#oblekani-image"
      imgSrc = @$oblekaniImageWrapper.data "image"
      image = new Image()
      image.onload = =>
        @$oblekaniImageWrapper.append $("<img src='#{image.src}'>")
        @$oblekaniImage = @$oblekaniImageWrapper.find ">img"
        @init()
        @renderAssetsGallery true
      image.src = imgSrc

      window.onresize = @windowResized

      @markFirstItemOfEveryCategory()

      @$el.find(".omalovanky_arrow").click @_rollClickEvent

    debug: (msg) =>
      if @options.debug
        console.log msg

    init: ->
      $(window).resize @_onResize
      @$itemsWrapper.find("li.item").click @_onItemClicked

      # clicked finish
      finishSelector = @options.done
      $(finishSelector).click @finish

    _rollClickEvent: (e)=>
      $el = $(e.target)
      $el.toggleClass "bgFlip"
      width = 80
      if !$el.hasClass "bgFlip"
        width = 80
        # also show only one item per category
        @$itemsWrapper.find("li.item:not('.first')").hide()
      else
        @$itemsWrapper.find("li.item:not('.first')").show()

      @$itemsWrapper.velocity
        width: width + 15 + "px"
      ,
        duration: 500

      $el.velocity
        right: width + 16 + "px"
      ,
        duration: 500

    markFirstItemOfEveryCategory: ->
      prevCategory = "-1"
      @$itemsWrapper.find("li.item").each ->
        $item = $(this)
        if $item.data("category") != prevCategory
          $item.addClass "first"
          prevCategory = $item.data "category"

    _onItemClicked: (e) =>
      $target = $(e.currentTarget)
      id = $target.attr("id")
      opacity = 0
      if $target.hasClass("active")
        $target.removeClass("active")
        $target.find(".dismiss").removeClass("navigation_close_small").attr("style","").find("svg").remove()
      else
        $target.addClass("active")
        $target.find(".dismiss").addClass("navigation_close_small")
        $.fn.setSvgInline $target.find(".dismiss")
        opacity = 1

      if @$oblekaniImageWrapper.find("##{id}").length == 0
        $image = @_createSvgElement($target.data("img"))
        .attr("id", id)
        .appendTo(@$oblekaniImageWrapper)
      else
        $image = @$oblekaniImageWrapper.find("##{id}")

      if ion.muted == false
        @debug "ion.sound.play"
        ion.sound.play("sound_click")

      $image.velocity
          opacity: opacity
        ,
          duration: 1000
          complete: ->
            if opacity == 0
              $image.remove()

    _createSvgElement: (url) ->
      $('<div class="item" />').css
        "background-image": "url(#{url})"
        opacity: 0

    # Assets to dress with
    renderAssetsGallery: (recalculate = false)=>
#      @$itemsWrapper
      size =
        width: @$el.width()
        height: @$el.height()
      @destroySlider()
      if size.width > size.height
#        assets on the right
        @$itemsWrapper.css("padding", "0")

        @$itemsWrapper.find('li').css("margin","-1px 0 0 -1px")
        if size.height < 800
          itemsWidth = "175px"
#        reset margins for items
          @$itemsWrapper.find('li:nth-of-type(-n+2)').css("margin","0 0 0 -1px")
        else
          @$itemsWrapper.find('li:nth-of-type(-n+1)').css("margin","0 0 0 -1px")
          itemsWidth = "95px"

        @$oblekaniImage.css { "max-height": "100%" }
        @$itemsWrapper.css
          right: 0, left: 'auto', top: 0, bottom: 'auto'
          width: itemsWidth, height: "90%"
        itemsWidth = @$itemsWrapper.width()
        @$oblekaniImage.css "max-width": @$el.width() - itemsWidth
#        reset item dimensions for big resolution (can be altered dynamically for small resolutions below)
        @$itemsWrapper.find("li").css "width": "80px", "height": "80px"
      else
#        asset at the bottom
        @$oblekaniImage.css { "max-width": '100%', "max-height": "100%" }
#        get width of our wrapper and set height according to items
        sideSize = Math.floor((parseFloat(@$itemsWrapper.css("width","100%").width()) / 6)*10)/10
        @$itemsWrapper.css
          right: 'auto', left: 0, top: 'auto', bottom: 0, height: sideSize+1
        .find('li').css("margin","0 -1px 0 0")
#          margin main image if needed
        @$oblekaniImage.css "max-height": @$el.height() - sideSize
#        set item dimensions to match slider etc (6 items in one row, 2 of which are arrows)
        @$itemsWrapper.css "padding", "0 #{sideSize}px"

        @$itemsWrapper.find("li").css width: sideSize+0.5, height: sideSize
        @destroySlider()
        @initSlider()
        @$itemsWrapper.find(".slick-arrow, .slick-arrow svg").css width: sideSize, height: sideSize
        @$itemsWrapper.find(".slick-track").css("height",sideSize+1)

        if recalculate then $(window).resize()

    initSlider: =>
      @sliderActive = true
      @$itemsWrapper.slick
        slidesToScroll: 1
        prevArrow: '<div class="navigation_back action"></div>'
        nextArrow: '<div class="navigation_next action"></div>'
        variableWidth: true
        infinite: false
        speed: 100
      @$itemsWrapper.find(".slick-arrow").each -> $.fn.setSvgInline $(this)

    destroySlider: =>
      if @sliderActive then @$itemsWrapper.slick('unslick')
      @sliderActive = null


    windowResized: =>
      @renderAssetsGallery()

    finish: (e)=>
      e.preventDefault()
      activeImages = []
      @$oblekaniImageWrapper.find(".item").each ->
        $self = $(this)
        if parseInt($self.css("opacity")) == 1
          activeImages.push $self.attr("id").replace("item-","")
      console.log activeImages

      $imagesData = $('<input type="text" name="images" />').val activeImages.join()
      finishSelector = @options.done

      $('#sendOblekani')
      .attr("action", $(finishSelector).attr("href"))
      .append($imagesData)
      .submit()




  # Define the plugin
  $.fn.extend oblekani: (option, args...) ->
    @each ->
      $this = $(this)
      data = $this.data('oblekani')

      if !data
        $this.data 'oblekani', (data = new Oblekani(this, option))
      if typeof option == 'string'
        data[option].apply(data, args)

) window.jQuery, window